<template>
  <div class="animated fadeIn step-container clinic-multi">
    <div class="row">
      
        <div class="col-12">
          <h1>สถานประกอบการในเครือ {{user.clinic_brand.name}}</h1>
          <p>กรุณาเลือกสาขาที่ต้องการ</p>
        </div>
        <div class="col-sm-12 col-md-4" v-for="c in clinics" :key="c.id">
          
            <div class="card">
              <div class="card-body text-center">
                <router-link :to="{ path: '/clinic/general', query: { ref_clinic_id: c.id }}">
                  <img :src="c.active_image" class="rounded mx-auto d-block clinic-image" >
                  <h4>{{c.clinic_name}}</h4>
                </router-link>
                <p>{{c.b_addr}}</p>
              </div>
            </div>
          
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: this.$guser.user,
      clinics: this.$guser.user.clinics ? this.$guser.user.clinics : null,
      error: null
    }
  },
  methods: {
    setData (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.clinics = data
      }
    }
  }
}
</script>
<style lang='scss'>
.clinic-multi{
  .card-body{
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
  .clinic-image{
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// ClinicMulti.vue?5825dbef